/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
const Terms = () => {
  const handleClick = () => {
    window.location.href = "/";
  };
  return (
    <>
      {/* saved from url=(0051)https://getbootstrap.com/docs/4.0/examples/pricing/ */}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* Meta Title */}
      <title>
        Norton Antivirus Activation &amp; Support | Redeem Product Key &amp;
        Contact Support
      </title>
      {/* Meta Description */}
      <meta
        name="description"
        content="Redeem your Norton Antivirus product key and activate your protection today! Need help? Our support team is available to assist with any issues or questions you may have."
      />
      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="Norton Antivirus, redeem product key, activate Norton, Norton support, antivirus activation, product key support, contact Norton support, Norton customer service"
      />
      {/* Meta Robots */}
      <meta name="robots" content="index, follow" />
      {/* Open Graph Meta Tags (for social media sharing) */}
      <meta
        property="og:title"
        content="Norton Antivirus - Redeem & Activate Product Key"
      />
      <meta
        property="og:description"
        content="Easily redeem and activate your Norton Antivirus product key. Our support team is here to assist with any activation issues or technical inquiries."
      />
      <meta property="og:image" content="" />
      <meta property="og:url" content="www.pcscancare.com" />
      <meta property="og:type" content="website" />
      {/* Twitter Card Meta Tags (for Twitter sharing) */}
      <meta
        name="twitter:title"
        content="Norton Antivirus - Activate Your Product Key & Get Support"
      />
      <meta
        name="twitter:description"
        content="Redeem your Norton Antivirus product key, activate your protection, and reach out to our support team for any help or troubleshooting needs."
      />
      <meta name="twitter:image" content="" />
      <meta name="twitter:card" content="summary_large_image" />
      {/* Canonical Link */}
      <link rel="canonical" href="www.pcscancare.com" />
      <link rel="icon" href="/nlok.ico" />

      <div className="header-section border-bottom box-shadow">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white ">
            <h5 className="my-0 mr-md-auto font-weight-normal">
              <img src="/main-logo.svg" alt="main logo" onClick={handleClick} />
            </h5>
            <nav className="my-2 my-md-0 mr-md-3">
              <Link className="p-2 text-dark" to="/privacy">
                Privacy Policy
              </Link>
              <Link className="p-2 text-dark" to="/terms">
                Terms &amp; Conditions
              </Link>
              <span className="p-2 text-dark">
                <strong>Contact US: +1 (805) 222-0570 </strong>
              </span>
            </nav>
          </div>
        </div>
      </div>
      <div className="main">
        <header
          style={{
            background: "#242e39",
            color: "white",
            padding: "100px 0",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1>Terms and Conditions</h1>
                <div
                  style={{
                    background: "yellow",
                    width: 100,
                    height: 3,
                    marginTop: 20,
                  }}
                />
              </div>
            </div>
          </div>
        </header>
        <div className="container">
          <div className="row">
            <main>
              <section className="mt-5">
                <h4>Introduction</h4>
                <p>
                  Welcome to PCScanCare! These Terms and Conditions govern your
                  use of our website, PCScanCare.com, which provides setup
                  guides and information for Norton Antivirus software. By
                  accessing or using this website, you agree to comply with and
                  be bound by these Terms and Conditions.
                </p>
                <h4>Acceptance of Terms</h4>
                <p>
                  By using PCScanCare.com, you agree to these Terms and
                  Conditions and any future modifications. If you do not agree
                  to these terms, please do not use our website.
                </p>
                <h4>Use of the Website</h4>
                <p>
                  You may use the content and resources available on PCScanCare
                  for personal and informational purposes only. You may not
                  distribute, modify, transmit, reuse, or reproduce the
                  materials on this website for commercial purposes without
                  written permission from PCScanCare.
                </p>
                <h4>Intellectual Property</h4>
                <p>
                  The content on this website, including text, graphics, logos,
                  and images, is the property of PCScanCare or its content
                  providers and is protected by copyright laws. Unauthorized use
                  of the content may violate copyright laws and result in legal
                  action.
                </p>
                <h4>Accuracy of Information</h4>
                <p>
                  While PCScanCare strives to provide accurate and up-to-date
                  information, we do not guarantee the accuracy, completeness,
                  or reliability of the content found on the site. We are not
                  responsible for any errors or omissions or for the results
                  obtained from the use of this information.
                </p>
                <h4>Third-Party Links</h4>
                <p>
                  Our website may contain links to third-party websites. These
                  links are provided for your convenience, and PCScanCare is not
                  responsible for the content or practices of these external
                  sites. Accessing any third-party websites is at your own risk.
                </p>
                <h4>Disclaimer of Warranties</h4>
                <p>
                  PCScanCare provides the information on this website "as is"
                  and makes no representations or warranties of any kind,
                  express or implied, regarding the operation of the website or
                  the information, content, or materials included on this site.
                  You agree that your use of this website is at your own risk.
                </p>
                <h4>Limitation of Liability</h4>
                <p>
                  In no event shall PCScanCare be liable for any damages
                  (including, without limitation, indirect, incidental, or
                  consequential damages) arising from your use or inability to
                  use this website or any linked third-party website.
                </p>
                <h4>Indemnification</h4>
                <p>
                  You agree to indemnify, defend, and hold harmless PCScanCare,
                  its officers, employees, and affiliates from any claim,
                  liability, loss, damage, or expense (including legal fees)
                  arising out of your violation of these Terms and Conditions or
                  your use of this website.
                </p>
                <h4>Changes to Terms and Conditions</h4>
                <p>
                  PCScanCare reserves the right to modify or update these Terms
                  and Conditions at any time without prior notice. Any changes
                  will be posted on this page with the updated date. Your
                  continued use of the website after any changes constitutes
                  your acceptance of the new Terms and Conditions.
                </p>
                <h4>Governing Law</h4>
                <p>
                  These Terms and Conditions shall be governed by and construed
                  in accordance with the laws of [Insert your jurisdiction]. Any
                  disputes arising from the use of this website shall be subject
                  to the exclusive jurisdiction of the courts in [Insert your
                  jurisdiction].
                </p>
                <h4>Contact Information</h4>
                <p>
                  If you have any questions regarding these Terms and
                  Conditions, please contact us at:
                </p>
                <p>Email: support@pcscancare.com</p>
              </section>
            </main>
          </div>
        </div>
        <div className="container py-5 mt-4 border-top">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/tech.svg" alt="tech" />
                <div className="text-center mt-3">
                  <h5>
                    Technology blocks thousands
                    <br /> of threats every minute.
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/exp.svg" alt="exp" />
                <div className="text-center mt-3">
                  <h5>
                    Count on decades of experience
                    <br /> and a proven track record
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/pro.svg" alt="pro" />
                <div className="text-center mt-3">
                  <h5>
                    Get the protection you and your
                    <br /> family need in one place.
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award3.svg" alt="award3" />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award2.svg" alt="award2" />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-4 pt-5">
              <div className="wrapper text-center">
                <img src="/award1.svg" alt="award1" />
              </div>
            </div>
          </div>
        </div>
        <footer className="py-4 border-top">
          <div className="container d-flex justify-content-between align-items-center">
            <p style={{ fontSize: 12 }}>
              Copyright © 2024 Gen Digital Inc. All rights reserved.
            </p>
            <img src="/main-logo.svg" alt="Main Logo" />
          </div>
        </footer>
      </div>
      {/* Bootstrap core JavaScript
    ================================================== */}
      {/* Placed at the end of the document so the pages load faster */}
      <grammarly-desktop-integration data-grammarly-shadow-root="true">
        <template shadowrootmode="open" />
      </grammarly-desktop-integration>
    </>
  );
};
export default Terms;
